import React from "react";
import { HorizontalBar } from "react-chartjs-2";
import PropTypes from "prop-types";

const options = {
  options: {},
  legend: {
    display: true
  }
};

const datasetKeyProvider = () => {
  return btoa(Math.random()).substring(0, 120);
};

const GradeDistributionChart = ({ data }) => {
  return (
    <div>
      <HorizontalBar
        data={data}
        options={options}
        base={10}
        datasetKeyProvider={datasetKeyProvider}
      />
    </div>
  );
};

export default GradeDistributionChart;

GradeDistributionChart.propTypes = {
  data: PropTypes.shape({
    datasets: PropTypes.array,
    labels: PropTypes.array
  }).isRequired
};
